import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
const Error = () => {
  return (
    <Wrapper>
      <h1>404: Stuff not found!</h1>
      <h3>
        {' '}
        sorry, the page you tried to reach can't come to the browser right now.
        Please
      </h3>
      <Link className='btn' to='/'>
        Try Again
      </Link>
    </Wrapper>
  );
};
const Wrapper = styled.section`
  min-height: 100vh;
  display: grid;
  place-items: center;
  background: var(--clr-primary-10);
  text-align: center;
  h1 {
    font-size: 6rem;
  }
  h3 {
    color: var(--clr-grey-3);
    margin-bottom: 1.5rem;
  }
  .btn {
    font-size: 2rem;
  }
`;
export default Error;
